import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRobot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRobot"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 4V2H11.25V4H2.5V8H1.5V12H2.5V16.25C2.5 18.3211 4.17893 20 6.25 20H17.75C19.8211 20 21.5 18.3211 21.5 16.25V12H22.5V8H21.5V4H12.75ZM8.5 8.5C7.67157 8.5 7 9.17157 7 10C7 10.8284 7.67157 11.5 8.5 11.5C9.32843 11.5 10 10.8284 10 10C10 9.17157 9.32843 8.5 8.5 8.5ZM15.5 8.5C14.6716 8.5 14 9.17157 14 10C14 10.8284 14.6716 11.5 15.5 11.5C16.3284 11.5 17 10.8284 17 10C17 9.17157 16.3284 8.5 15.5 8.5ZM9 14V15.5H15V14H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRobot;
